import React from 'react';
import Accordion from '@material-ui/core/Accordion';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import styled from 'styled-components/macro';
import * as cs from 'common/common-styles';
import { AccordionItemGeneric } from './accordion-item-generic';
import { withVisibility } from '../utils/with-visibility';

const StyledAccordion = styled(Accordion)`
  ${cs.greyBackground}
`;

const StyledAccordionSummary = styled(AccordionSummary)`
  ${cs.greyBackground}
`;

// See "AccordionItem" of "types/fields/component-props/question-answer-accordion.ts"
function QuestionAnswerAccordionComponent({ additionalCSS, header, accordionItems }) {
  return (
    <StyledAccordion css={additionalCSS}>
      <StyledAccordionSummary expandIcon={<ExpandMoreIcon />}>{header}</StyledAccordionSummary>

      <cs.AccordionDetail>
        {accordionItems.map((el, _idx) => {
           return <AccordionItemGeneric key={`QAA-${_idx}`} {...el} />;
        })}
      </cs.AccordionDetail>
    </StyledAccordion>
  );
}

export const QuestionAnswerAccordionGeneric = withVisibility(QuestionAnswerAccordionComponent);

